<script setup lang="ts">
import { NConfigProvider, NMessageProvider, NDialogProvider, NLoadingBarProvider, darkTheme } from 'naive-ui';
import { zhCN, dateZhCN } from 'naive-ui';
import { RouterView } from 'vue-router';
import { computed } from 'vue';

// Naive-UI theme overrides — warm (Aurora-aligned) tint on the primary color
const themeOverrides = computed(() => ({
  common: {
    primaryColor: '#ff7e5f',
    primaryColorHover: '#ff9a7f',
    primaryColorPressed: '#e66a4f',
    primaryColorSuppl: '#e85d75',
    infoColor: '#feb47b',
    successColor: '#9bd67e',
    warningColor: '#ffd66b',
    errorColor: '#e85d75',
    fontFamily: 'Inter, "Noto Sans SC", -apple-system, sans-serif',
    fontFamilyMono: '"JetBrains Mono", Menlo, monospace',
    bodyColor: '#141016',
    baseColor: '#1a0b1f',
    cardColor: 'rgba(32, 20, 38, 0.82)',
    popoverColor: '#221628',
    modalColor: '#1a0f22',
    borderRadius: '8px',
  },
}));
</script>

<template>
  <NConfigProvider :theme="darkTheme" :theme-overrides="themeOverrides" :locale="zhCN" :date-locale="dateZhCN">
    <NLoadingBarProvider>
      <NDialogProvider>
        <NMessageProvider>
          <RouterView />
        </NMessageProvider>
      </NDialogProvider>
    </NLoadingBarProvider>
  </NConfigProvider>
</template>
